import { render } from "./PriceGroupList.vue?vue&type=template&id=bf3551f4&scoped=true&ts=true"
import script from "./PriceGroupList.vue?vue&type=script&lang=ts"
export * from "./PriceGroupList.vue?vue&type=script&lang=ts"

import "./PriceGroupList.vue?vue&type=style&index=0&id=bf3551f4&scoped=true&lang=scss"

import exportComponent from "D:\\YellowBeardProject\\caffeine\\caffeineshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf3551f4"]])

export default __exports__